module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/aerobics-girl.png?fef4c69a36e2d952d250bf7ee4eeb6f0";